import { Injectable } from '@angular/core';
import { List } from '../models/common/list.model';
import { CustomFilterTable } from '../models/custom-filters/custom-filter-table.model';

@Injectable({
  providedIn: 'root'
})
export class CustomFiltersTabletService {
  activateFilters = false;
  customFiltersTable: CustomFilterTable[] = [];
  customFilterQuery: { [type: string]: any[]; } = {};
  customFilterSelectionOptions: { [type: string]: any; } = {};

  constructor() { }

  /**
   * Create an object with the necessary filters for query 
   * @param filters Name of the filters for queries
   * @usageNotes Example of filters: 
   * filters = {
   * Areas: 'areas'
   * };
   * Where 'areas' is the name in backend
   *   
   */
  createCustomFilterQuery(filters: { [type: string]: any; }) {
    Object.entries(filters).map(([key, value]) => {
      this.customFilterQuery[value] = [];
    });
  }


  /**
   * Validate if the filter already exists and / or add
   * @param filter Sent from custom filter component
   */
  validateCustomFilterAndAdd(filter: { FilterType: string, Filter: any } | []) {
    this.activateFilters = true;
    if (Array.isArray(filter)) { this.resetFilterQuery(); }
    else {
      this.customFiltersTable.forEach(customFilter => {
        if (customFilter.FilterType === filter.FilterType) {
          Array.isArray(filter.Filter)
            ? customFilter.FiltersList = filter.Filter
            : !customFilter.FiltersList.some((currentFilter: any) => currentFilter.id === filter.Filter.id)
              ? customFilter.FiltersList.push(filter.Filter)
              : customFilter.FiltersList = customFilter.FiltersList;
        }
      });

      const currentFilters = Array.from(this.customFiltersTable);
      this.customFiltersTable = currentFilters;

      Object.entries(this.customFilterQuery).map(([key, value]) => {
        if (filter.FilterType === key) {
          this.customFilterQuery[key] = this.isFoundFilter(value, filter.Filter);
        }
      });
    }
  }

  /**.
   * Reset filters to array empty
   */
  private resetFilterQuery() {
    this.customFiltersTable.forEach(filter => filter.FiltersList = []);
    Object.entries(this.customFilterQuery).map(([key, value]) => {
      this.customFilterQuery[key] = [];
    });
  }

  private isFoundFilter(filtersQuery: string[], selectedFilter: any | any[]) {
    if (Array.isArray(selectedFilter)) {
      filtersQuery = [];
      selectedFilter.forEach(selectFilter => {
        filtersQuery.push(selectFilter.id);
      });
    } else {
      filtersQuery.find(filter => filter === selectedFilter.id)
        ? filtersQuery.splice(filtersQuery.indexOf(selectedFilter.id), 1)
        : filtersQuery.push(selectedFilter.id);
    }
    return filtersQuery;
  }

  validateIfThereFilters() {
    for (const filter of Object.values(this.customFilterQuery)) {
      if (filter.length === 0) {
        continue;
      } else {
        return false;
      }
    }
    return true;
  }

  initFilter(filter: CustomFilterTable) {
    const title = filter.Title;

    filter.SelectorOptions = {
      title,
      serverSide: true,
      itemTemplate: '<div class="ark-select-item-name"><strong>{{text}}</strong> </div>',
      processResult: (items: List<any>) => ({
        results: items.Data.map(obj => {
          const value = this.convertFIlterToIdAndText(obj);
          return {
            id: value[0],
            text: value[1] || value[0]
          };
        })
      }),
      allowPagination: true,
      url: filter.Url
    };

    this.customFiltersTable.push(filter);
    this.customFilterSelectionOptions[filter.FilterType] = filter.SelectorOptions;
  }

  private convertFIlterToIdAndText(obj: string) {
    const value = obj.split('||');
    return value;
  }
}
